import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProfileResponse, UserProfile } from '../models/user-profile.model';
import { ProfileListingsResponse } from '../models/announcement.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private readonly apiUrl = `${environment.apiUrl}/Profile`;
  private http = inject(HttpClient);

  getMe(): Observable<ProfileResponse> {
    return this.http.get<ProfileResponse>(`${this.apiUrl}/me`);
  }

  updateProfile(profile: Partial<UserProfile>): Observable<ProfileResponse> {
    // Hazırda yalnız GET endpoint-i verilib, lakin save düyməsi üçün bu lazımdər.
    // Endpoint adını ehtimal olaraq 'update' və ya 'me' (PUT/PATCH) qoyuruq.
    return this.http.put<ProfileResponse>(`${this.apiUrl}/me`, profile);
  }

  getListings(): Observable<ProfileListingsResponse> {
    return this.http.get<ProfileListingsResponse>(`${this.apiUrl}/listings`);
  }

  getListingById(id: number | string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/listings/${id}`);
  }

  updateListing(id: number | string, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/listings/${id}`, data);
  }

  pauseListing(id: number | string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/listings/${id}/pause`, {});
  }

  activateListing(id: number | string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/listings/${id}/activate`, {});
  }
}
